module.exports = __webpack_public_path__ + "img/download.5fc307f1.svg";